<template>
  <div class="overlay" v-if="active">
    <div class="modal">
      <div class="layout">
        <div class="item">
          <a
            href="#"
            class="btn navigation-icon close"
            v-on:click.prevent="active = false"
          ></a>

          <div class="wrapper">
            <div class="content embed-responsive embed-responsive-16by9">
              <!-- <iframe class="embed-responsive-item" v-bind:src='`//players.brightcove.net/2750693505001/9KXeGhtDV4_default/index.html?videoId=6018245426001`'allowfullscreen webkitallowfullscreen mozallowfullscreen allow="encrypted-media" style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;"></iframe> -->
              <template v-if="aprimo_url">
                <video
                  class="embed-responsive-item video-js vjs-default-skin"
                  controls
                  preload="auto"
                  :data-setup="{}"
                  style="position: absolute; top:0; right:0; bottom:0; left:0; width:100%; height:100%;"
                >
                  <source :src="aprimo_url" type="application/x-mpegURL" />
                  <track 
                    v-if="inlineSubtitleTrack"
                    kind="captions" 
                    :src="inlineSubtitleTrack.src"
                    :srclang="inlineSubtitleTrack.srclang"
                    :label="inlineSubtitleTrack.label"
                  />
                </video>
              </template>
              <template v-else>
                <iframe
                  class="embed-responsive-item"
                  v-bind:src="`//players.brightcove.net/2750693505001/${player}_default/index.html?videoId=${id}`"
                  frameborder="0"
                  allowfullscreen
                  webkitallowfullscreen
                  mozallowfullscreen
                  allow="encrypted-media"
                  style="
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    bottom: 0px;
                    left: 0px;
                    width: 100%;
                    height: 100%;
                  "
                ></iframe>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="backdrop"><!-- backdrop --></div>
  </div>
</template>

<script>
import { scroll } from "../../mixins/index";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "modal-video",
  props: {
    item: {
      type: Object,
    },
  },
  mixins: [scroll],
  data() {
    return {
      active: false,
      player: "",
      id: "",
      aprimo_url: null,
      aprimo_subtitle: null,
      subtitles: null,
      playerInstance: null,
      escapeListener: null,
    };
  },
  watch: {
    active(val) {
      bus.$emit("overlay:active:boolean", val, this.player, this.id);
      document.body.style["overflow"] = val ? "hidden" : "visible";
      if (!val && this.playerInstance) {
        try {
          this.playerInstance.dispose();
        } catch (e) {
          // ignore
        }
        this.playerInstance = null;
      }
    },
  },
  computed: {
    inlineSubtitleTrack() {
      const tracks = this.getSubtitleTracks();
      return tracks.length ? tracks[0] : null;
    },
  },
  methods: {
    buildTrack(src, lang) {
      const safeLang = (lang || "en").trim() || "en";
      return {
        kind: "captions",
        src,
        srclang: safeLang,
        label: safeLang.toLowerCase() === "en" ? "English" : safeLang,
      };
    },
    parseSubtitleEntry(rawEntry, fallbackLang = "en") {
      const entry = (rawEntry || "").trim();
      if (!entry) {
        return null;
      }

      // Direct URL format: https://.../file.vtt
      if (/^https?:\/\//i.test(entry)) {
        return this.buildTrack(entry, fallbackLang);
      }

      // Lang-prefixed format: en:https://.../file.vtt
      const separatorIndex = entry.indexOf(":");
      if (separatorIndex === -1) {
        return null;
      }

      const langCandidate = entry.slice(0, separatorIndex).trim();
      const srcCandidate = entry.slice(separatorIndex + 1).trim();
      const looksLikeLang = /^[a-z]{2,3}(?:-[a-z0-9]+)*$/i.test(langCandidate);

      if (!looksLikeLang || !/^https?:\/\//i.test(srcCandidate)) {
        return null;
      }

      return this.buildTrack(srcCandidate, langCandidate);
    },
    getSubtitleTracks() {
      if (this.subtitles) {
        return this.subtitles
          .split(",")
          .map((track) => this.parseSubtitleEntry(track))
          .filter(Boolean);
      }

      if (!this.aprimo_subtitle) {
        return [];
      }

      const singleTrack = this.parseSubtitleEntry(
        this.aprimo_subtitle
      );

      return singleTrack ? [singleTrack] : [];
    },
    applySubtitleTracks() {
      if (!this.playerInstance || !this.playerInstance.remoteTextTracks) {
        return;
      }

      const remoteTracks = this.playerInstance.remoteTextTracks();
      while (remoteTracks.length) {
        this.playerInstance.removeRemoteTextTrack(remoteTracks[0]);
      }

      this.getSubtitleTracks().forEach((track) => {
        this.playerInstance.addRemoteTextTrack(track, false);
      });

      const allTracks = this.playerInstance.textTracks();
      for (let i = 0; i < allTracks.length; i += 1) {
        allTracks[i].mode = "disabled";
      }
    },
  },

  mounted() {
    // modal-video
    let hash = window.location.hash.substring(1);
    if (/^modal-video/.test(hash)) {
      // pattern
      // modal-video=true&video=abc&player=xyz;

      // example on:
      // en-us/sleep-apnea/snoring-sleep-apnea-diagnosis/what-causes-snoring/
      // modal-video=true&video=6093844709001&player=zzaavGefz

      let arr = hash.split("&"),
        id = arr[1].replace("video=", ""),
        player = arr[2].replace("player=", "");

      let component = $(`[modal-video-id="${id}"]`).closest(
        "[resmed-component-name]"
      )[0];

      if (component) {
        this.scroll({
          to: component,
          duration: 1200,
          callback: () => {
            this.active = true;
            this.player = player;
            this.id = id;
          },
        });
      } else {
        this.active = true;
        this.player = player;
        this.id = id;
      }
    }
  },
  created() {
    bus.$on("overlay:active", (arg) => {
      this.active = arg.active;
      this.player = arg.player;
      this.id = arg.id;
      this.aprimo_url = arg.aprimo_url || null;
      this.aprimo_subtitle = arg.aprimo_subtitle || null;
      this.subtitles = arg.subtitles || null;
    });

    this.escapeListener = window.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        this.active = false;
      }
    });
    // watch aprimo_url + active to initialize player
    bus.$on("overlay:active:boolean", (val) => {
      // when overlay becomes active, if aprimo_url present initialize player
      if (val && this.aprimo_url) {
        this.$nextTick(() => {
          const el = this.$el && this.$el.querySelector && this.$el.querySelector("video");
          if (el) {
            try {
              this.playerInstance = videojs(el, {
                controls: true,
                controlBar: {
                  subsCapsButton: true,
                },
                html5: {
                  vhs: {
                    enableLowInitialPlaylist: true,
                  },
                },
              });
              this.applySubtitleTracks();
            } catch (e) {
              // ignore init errors
            }
          }
        });
      }
      // when closing, dispose handled in active watcher
    });
  },
  beforeDestroy() {
    if (this.playerInstance) {
      try {
        this.playerInstance.dispose();
      } catch (e) {
        // ignore dispose errors
      }
      this.playerInstance = null;
    }
    window.removeEventListener(this.escapeListener);
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/components/modal";

.overlay {
  .layout {
    position: relative;
    margin: 6rem auto 0 auto;
    width: 960px;
    max-width: 90vw;
    box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.75);

    @media (min-height: 800px) {
      margin: 12rem auto 0 auto;
    }
  }
}
</style>